import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import ReactSVG from 'react-svg'
import classnames from 'classnames'

import { toggleNavigationVisibility } from '../../actions'
import styles from './navigation-burger-icon.css'
import burgerIcon from '../../../images/burger-new.svg'
import crossIcon from '../../../images/cross.svg'
import { E2E_SELECTORS } from '../../e2e-selectors'

/**
 * NavigationBurgerIcon renders the hamburger menu icon in the header and the cross icon in the side.
 * It toggles between burger and cross icons when the menu is open.
 */
function NavigationBurgerIcon({
  display,
  className
}) {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(toggleNavigationVisibility())
  }

  return (
    <div
      className={`${styles.burgerIcon} ${className}`.trim()}
      onClick={handleClick}
    >
      <ReactSVG
        src={display ? crossIcon : burgerIcon}
        beforeInjection={(svg) => {
          svg.setAttribute('class', classnames(styles.iconSVG, {
            [styles.cross]: display
          }))
        }}
        className={styles.iconSVGWrapper}
        data-lbx-e2e={E2E_SELECTORS.HAMBURGER_ICON}
      />
    </div>
  )
}

NavigationBurgerIcon.propTypes = {
  display: PropTypes.bool.isRequired,
  className: PropTypes.string
}

NavigationBurgerIcon.defaultProps = {
  className: ''
}

export default NavigationBurgerIcon
